

var isHidden = function isHidden(obj) {
    return !!obj.isHidden || !!obj.hidden;
};


export default isHidden;
import { bpfrpt_proptype_Template } from './flowTypes';
import { bpfrpt_proptype_TemplateField } from './flowTypes';